module.exports = __webpack_public_path__ + "img/user-empty.4603c30f.png";